import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import QRCode from "qrcode";

const PreviewFamilia = ({ show, onHide, content, count = 1, scale }) => {


  // console.log('content ', content)

  const [qrCode, setQrCode] = useState("");

  // ============================================================
  // GENERATE QR CODE
  // ============================================================
  useEffect(() => {
    const generateQR = async () => {
      try {
        // ========================================================
        // QR CODE NOW LINKS TO LERROS CONTACT PAGE
        // Scanning this QR code will open the Lerros HQ contact page
        // ========================================================
        const qrData = "https://company.lerros.com/de/kontakt/zentrale";

        const qr = await QRCode.toDataURL(qrData, {
          width: 150,
          margin: 0,
          errorCorrectionLevel: "M",
        });

        setQrCode(qr);
      } catch (error) {
        console.error("QR Code generation error:", error);
        setQrCode("");
      }
    };

    generateQR();
  }, []);



  // const {header , TotalQtys }= content ;

  // const header = content?.header || [];
  // const TotalQtys = content?.TotalQtys || [];
  // header.pop();
  // const qty = TotalQtys.pop();

  const header = [...(content?.header || [])];
  const TotalQtys = [...(content?.TotalQtys || [])];

  const qty = TotalQtys[TotalQtys.length - 1];

  header.pop();
  TotalQtys.pop();

  // console.log('scale check?', scale)
  // console.log('content???', content)

  // Combine headers and quantities, excluding zeros
  const combinedData = [];

  // Create combinations of headers and quantities
  for (let i = 0; i < Math.min(header.length, TotalQtys.length); i++) {
    const qty = Number(TotalQtys[i]); // Convert quantity to number
    if (qty !== 0) {
      combinedData.push({
        header: header[i],
        quantity: qty,
      });
    }
  }

  // this.length = combinedData.length;
  // console.log(this.length);
  // Split into two arrays of length 6 for valid entries only
  const headerData = combinedData.map((item) => item.header);
  const quantitiesData = combinedData.map((item) => item.quantity);

  // Generate table headers
  const tableHeader = headerData
    .map((dt) => `<td class="innerTab">${dt}</td>`)
    .join("");
  const tableData = quantitiesData
    .map((dt) => `<td class="innerTab">${dt}</td>`)
    .join("");

  const carton_size = `${content?.length} X ${content?.width} X ${content?.height}`;


  const tbl = `
            <div class="container">
            <div class="qr-main-div">
      <table>
        <tr>
          <th id="left">BUYER/ ПОКУПАТЕЛЬ*</th>
          <th id="right" style="width: 56%">
            LLC MAXIMA GROUP/ ООО «МАКСИМА ГРУПП»
          </th>
        </tr>
        <tr>
          <th id="left">SELLER/ ПРОДАВЕЦ*</th>
          <th id="right">LERROS MODEN GMBH LTD.</th>
        </tr>
        <tr>
          <th id="left">ORDER #/ HOМЕР ЗАКАЗА*</th>
          <th id="right">${content?.orderNo || ""}</th>
        </tr>
        <tr>
          <th id="left">CARTON NUMBER/ № КОРОБА*</th>
          <th id="right">${content?.SNO || ""}</th>
        </tr>
        <tr>
          <th id="left">Artcle/ АРТИКУЛ*</th>
          <th id="right">${content?.STY || ""}</th>
        </tr>
        <tr>
          <th id="left">QUANTITY/ КОЛИЧЕСТВО*</th>
          <th id="right">${content ? content?.QtyPcs : " "} Pcs</th>
        </tr>
        <tr>
          <th id="left">BRAND/ΤΟΡΓОВАЯ МАРКА</th>
          <th id="right">LRS</th>
        </tr>
        <tr>
          <th id="left">SIZE/PA3MEP</th>
          <th id="right">
            <table class="inTab" style="border: 2px solid white">
            <thead>
              <tr>
                ${tableHeader}
              </tr>
            </thead>
            <tr>${tableData} </tr>
          </table>
            
          </th>
        </tr>
        <tr>
          <th id="left">COLOR/ ЦВЕТ</th>
          <th id="right">${content?.CLRS || ""}</th>
        </tr>
        ${content?.DIM?.length > 0
      ? `<tr><th id="left">DIM</th><th id="right">${content?.DIM || ""
      } </th></tr>`
      : ""
    }
        <tr>
          <th id="left">MADE IN/ СДЕЛАНО В</th>
          <th id="right">${content?.country || ""}</th>
        </tr>
        <tr>
            <th id="left" style="width: 47%">GROSS WEIGHT/ВЕС БРУТТО КОРОБА</th>
            <th id="right">${content?.GrossWt || ""} Kgs</th>
          </tr>
          <tr>
            <th id="left">NET WEIGHT/BЕС НЕТТО КОРОБА</th>
            <th id="right">${content?.NetWt || ""} Kgs</th>
          </tr>
          <tr>
            <th id="left">CARTON SIZE/ РАЗМЕР КОРОБА</th>
            <th id="right">${carton_size} CM</th>
          </tr>
          
        </table>

        <div class="container_1_qr">
              <div class="qr-main">
                  <div class="carton-id">${content?.carton_ID}</div>
                  <img
                    src="${qrCode}"
                    class="qr-code"
                    alt="QR Code"
                  />
               </div>
          </div>
          </div>
        
      <div class="common-cell barcode-cell">
        // ${content?.svg}
        
      </div>
      <div class="cut_line_main">
        <span id="cut_logo">&#x2702;</span>
        <div class="cut_line"></div>
      </div>



      <div class="second_container">
       <div class="qr-main-div">
        <table>
          <tr>
            <th id="left">BUYER/ ПОКУПАТЕЛЬ*</th>
            <th id="right" style="width: 56%">
              LLC MAXIMA GROUP/ ООО «МАКСИМА ГРУПП»
            </th>
          </tr>
          <tr>
            <th id="left">SELLER/ ПРОДАВЕЦ*</th>
            <th id="right">LERROS MODEN GMBH LTD.</th>
          </tr>
          <tr>
            <th id="left">ORDER #/ HOМЕР ЗАКАЗА*</th>
            <th id="right">${content?.orderNo || ""}</th>
          </tr>
          <tr>
            <th id="left">CARTON NUMBER/ № КОРОБА*</th>
            <th id="right">${content?.SNO || ""}</th>
          </tr>
          <tr>
            <th id="left">Artcle/ АРТИКУЛ*</th>
            <th id="right">${content?.STY || ""}</th>
          </tr>
          <tr>
            <th id="left">QUANTITY/ КОЛИЧЕСТВО*</th>
            <th id="right">${content ? content?.QtyPcs : ""} Pcs</th>
          </tr>
          <tr>
            <th id="left">BRAND/ΤΟΡΓОВАЯ МАРКА</th>
            <th id="right">LRS</th>
          </tr>
           <tr>
          <th id="left">SIZE/PA3MEP</th>
          <th id="right">
            <table class="inTab"  style="border: 2px solid white">
            <thead>
              <tr>
                ${tableHeader}
              </tr>
            </thead>
            <tr>${tableData} </tr>
          </table>
            
          </th>
        </tr>
          <tr>
            <th id="left">COLOR/ ЦВЕТ</th>
            <th id="right">${content?.CLRS || ""}</th>
          </tr>
          ${content?.DIM?.length > 0
      ? `<tr><th id="left">DIM</th><th id="right">${content?.DIM || ""
      } </th></tr>`
      : ""
    }
          <tr>
            <th id="left">MADE IN/ СДЕЛАНО В</th>
            <th id="right">${content?.country || ""}</th>
          </tr>
          <tr>
            <th id="left" style="width: 47%">GROSS WEIGHT/ВЕС БРУТТО КОРОБА</th>
            <th id="right">${content?.GrossWt || ""} Kgs</th>
          </tr>
          <tr>
            <th id="left">NET WEIGHT/BЕС НЕТТО КОРОБА</th>
            <th id="right">${content?.NetWt || ""} Kgs</th>
          </tr>
          <tr>
            <th id="left">CARTON SIZE/ РАЗМЕР КОРОБА</th>
            <th id="right">${carton_size} CM</th>
          </tr>
          
        </table>

        <div class="container_1_qr">
              <div class="qr-main">
                  <div class="carton-id">${content?.carton_ID}</div>
                  <img
                    src="${qrCode}"
                    class="qr-code"
                    alt="QR Code"
                  />
               </div>
          </div>
        </div>

        <div class="common-cell barcode-cell">
        
          // ${content?.svg} 
          
        </div>
      </div>
    </div>`;

  const htmlContent = `<html lang="en">
    <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Complex Table with Flexbox</title>
   <style>
    .tables-container{
        // border :2px solid red;
        margin: 0;
        padding: 0;
      }
      .container {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0;
        padding: 0;
        width: 100%;
        flex-direction: column;
      }
       .qr-main-div{
      display: flex;
      justify-content: space-between;
      align-items: end;
      position: relative;   /* was: postion */
    }

      table,
      th {
        border: 3px solid black;
        border-collapse: collapse;
        font-weight: 550;
        margin: 0;
        padding: 0;
      }
    .innerTab{
      // border:2px solid red;
      width: 50px;
      text-align:center;
        margin: 0;
        padding: 0;
    }
      th,
      td {
        padding: 1px;
        text-align: left;
      }
      .common-cell {
        display: flex;
        flex-direction: column;
        text-align: center;
        height: 200px;
      }
      .barcode-cell {
        padding: 10px;
        padding-bottom: 11px;
        width: 500px;
        /* max-height: 200px; */
        /* border: 1px solid #000; */
        /* border-bottom: 2px solid #000; */
        /* border-top: none; */
        
        display:none;
      }
      .cut_line_main {
        border: 2px solid white;
        background: #f0f0f0;
        display: flex;
        width: 100%;
        align-items: center;
        height: 2vh;
        margin: 30px;
      }
      #cut_logo {
        /* border: 2px solid black; */
        width: 2%;
        height: 2vh;
      }
      .cut_line {
        border-bottom: 1px dashed black;
        width: 98%;
        height: 0.1vh;
      }
      .second_container {
      display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        display: flex;
        flex-direction: column;
      }

         .qr-main {
        width: 100px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-direction: column;
}
    
      .qr-code {
         width: 68px;
         height: 70px;
         display: block;
         object-fit: contain;
        }

        .carton-id{
        padding: 0px 0px 10px 16px;
        font-weight: 500;
        font-size: 11px;
      }
        .innerTab{
        // width : 20px;
        padding : 2px;
        border :0px;
        text-align :center;
        border: 1px solid black !important; 
      }


      @media print {
        table,
        th,
        td {
          border-collapse: collapse;
          font-weight: 550;
        }
          .container{
          ${combinedData.length > 0 ? "margin-top : 30px" : ""}
          }
          .second_container{
            ${combinedData.length > 0 ? "margin-top : 30px" : ""}
          }
        .cut_line_main {
          border: 2px solid white;
          background: #f0f0f0;
          display: flex;
          width: 100%;
          align-items: center;
          height: 2vh;
         
        }
        .common-cell {
          display: flex;
          flex-direction: column;
          text-align: center;
          max-height: 100px;
        }
        .barcode-cell {
          padding: 10px;
          padding-bottom: 11px;
          width: 500px;
          max-height: 100px;
          /* border: 1px solid #000; */
          /* border-bottom: 2px solid #000; */
          /* border-top: none; */
        }
          .inTab{
          border :2px solid white;
          }
      .innerTab{
        width : 20px;
        padding : 2px;
        border :0px;
        text-align :center;
      }   

      }
   
    </style>

  </head>
      <body>
        <div class="tables-container">
              ${tbl}
        </div>
      </body>
  </html>`;
  return (
    // <Modal.Body
    //   style={{
    //     maxHeight: '70vh',
    //     overflow: 'auto',
    //     padding: '4px',
    //     backgroundColor: '#f8f9fa',
    //     // border: '2px solid blue',
    //     boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //   }}
    // >
    <div
      style={{
        width: "auto",
        height: "auto",
        overflow: "visible",
        zoom: scale,
        padding: "100px",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      dangerouslySetInnerHTML={{
        __html: htmlContent,
      }}
    />
    // </Modal.Body>
  );
};

export default PreviewFamilia;
